// extracted by mini-css-extract-plugin
export default {"inlineError":"styles_inlineError__uFl1a","inlineSuccess":"styles_inlineSuccess__iPtco","right":"styles_right__PuG5l","center":"styles_center__-tOY9"};